import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelMultiSelect } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { ModelCurrency } from 'hay-core-react';
import { ModelChips } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import Modalidade              from '../../../models/Modalidade';
import ModalidadePagamentoEnum from '../../../enums/ModalidadePagamentoEnum';
import TipoPagamentoEnum       from '../../../enums/TipoPagamentoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id:                  { exibir: 'main.id',                       tipo: 'numeric', largura: '5rem', fixar: true },
    nome:                { exibir: 'main.modalidade.nome',           visivel: true, validacao: { obrigatorio: true } },
    descricao:           { exibir: 'main.modalidade.descricao' },
    // strictobrigatorio (nao obrigatorio) - valor pode ser 0 (ex. modalidade Isento), e a
    // validacao "obrigatorio" trata 0 como falsy/vazio (ver UtilService.validarEsquema).
    valor:               { exibir: 'main.modalidade.valor',         visivel: true, tipo: 'currency', validacao: { strictobrigatorio: true }, template: 'valor.template' },
    custo:               { exibir: 'main.modalidade.custo',         tipo: 'currency', validacao: { strictobrigatorio: true }, template: 'custo.template' },
    limitemensalusuario: { exibir: 'main.modalidade.limitemensalusuario', tipo: 'numeric' },
    limitemensalsms:     { exibir: 'main.modalidade.limitemensalsms',     tipo: 'numeric' },
    limitemensalemail:   { exibir: 'main.modalidade.limitemensalemail',  tipo: 'numeric' },
    limitemensaltoken:   { exibir: 'main.modalidade.limitemensaltoken',  tipo: 'numeric' },
    // Franquia flexível (especificação 238) - limitefinal* não bloqueia o uso ao atingir
    // limitemensal*, continua até esse teto; precoexcedente* é o preço unitário cobrado pela
    // diferença no fechamento da competência (ContratoUtilizacao). Ambos allowNull no backend -
    // em branco = sem franquia flexível/sem cobrança de excedente pra aquele recurso.
    limitefinalusuario:    { exibir: 'main.modalidade.limitefinalusuario',    tipo: 'numeric' },
    limitefinalsms:        { exibir: 'main.modalidade.limitefinalsms',        tipo: 'numeric' },
    limitefinalemail:      { exibir: 'main.modalidade.limitefinalemail',      tipo: 'numeric' },
    limitefinaltoken:      { exibir: 'main.modalidade.limitefinaltoken',      tipo: 'numeric' },
    precoexcedenteusuario: { exibir: 'main.modalidade.precoexcedenteusuario', tipo: 'numeric' },
    precoexcedentesms:     { exibir: 'main.modalidade.precoexcedentesms',     tipo: 'numeric' },
    precoexcedenteemail:   { exibir: 'main.modalidade.precoexcedenteemail',   tipo: 'numeric' },
    precoexcedentetoken:   { exibir: 'main.modalidade.precoexcedentetoken',   tipo: 'numeric' },
    ativo:               { exibir: 'main.modalidade.ativo',          visivel: true, tipo: 'boolean', template: 'ativo.template' },
    modalidadepagamento: { exibir: 'main.modalidade.modalidadepagamento', tipo: 'multiselect', entidade: 'modalidade.modalidadepagamento', validacao: { obrigatorio: true } },
    tipopagamento:       { exibir: 'main.modalidade.tipopagamento',   visivel: true, tipo: 'enum', entidade: 'modalidade.tipopagamento' },
    slug:                { exibir: 'main.modalidade.slug',           validacao: { obrigatorio: true } },
    destaque:            { exibir: 'main.modalidade.destaque',       tipo: 'boolean', template: 'destaque.template' },
    ordemexibicao:       { exibir: 'main.modalidade.ordemexibicao',  tipo: 'numeric' },
    beneficios:          { exibir: 'main.modalidade.beneficios',     tipo: 'json' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

// EntityDataTable nao tem case default pra "boolean"/"currency" (so date/enum/bytes/byterate/
// url) - sem um template explicito, boolean renderiza em branco (React nao imprime true/false
// como texto) e currency aparece como numero cru. Mesmo padrao de Plano.padrao/
// Configuracao.ativarcaptive/Routerboard.ativo pro boolean.
const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);
const currencyTemplate = (campo) => (rowData) => UtilService.formatCurrency(rowData[campo]);

const renderers = {
    'modalidade.modalidadepagamento': ModalidadePagamentoEnum,
    'modalidade.tipopagamento':       TipoPagamentoEnum,
    'ativo.template':    booleanTemplate('ativo'),
    'destaque.template': booleanTemplate('destaque'),
    'valor.template':    currencyTemplate('valor'),
    'custo.template':    currencyTemplate('custo'),
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class ModalidadeFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.modalidade.aba.basica')} leftIcon="pi pi-home mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.nome} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.slug} contexto={contexto} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.descricao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelCurrency model={model.valor} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelCurrency model={model.custo} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.tipopagamento} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.ativo} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-8 mt-3">
                            <ModelMultiSelect model={model.modalidadepagamento} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelInputNumber model={model.limitemensalusuario} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelInputNumber model={model.limitemensalsms} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelInputNumber model={model.limitemensalemail} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelInputNumber model={model.limitemensaltoken} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.modalidade.aba.franquiaflexivel')} leftIcon="pi pi-arrow-up-right mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelInputNumber model={model.limitefinalusuario} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelInputNumber model={model.limitefinalsms} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelInputNumber model={model.limitefinalemail} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelInputNumber model={model.limitefinaltoken} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelInputNumber model={model.precoexcedenteusuario} contexto={contexto} minFractionDigits={2} maxFractionDigits={4} />
                        </div>
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelInputNumber model={model.precoexcedentesms} contexto={contexto} minFractionDigits={2} maxFractionDigits={4} />
                        </div>
                        <div className="field col-12 md:col-3 mt-3">
                            <ModelInputNumber model={model.precoexcedenteemail} contexto={contexto} minFractionDigits={2} maxFractionDigits={4} />
                        </div>
                        <div className="field col-12 md:col-3 mt-3">
                            {/* Token não tem franquia flexível nos planos padrão (card #49 - corte
                                rígido em limitemensaltoken), mas o campo continua editável pra quem
                                quiser ativar manualmente. maxFractionDigits maior que os demais
                                precoexcedente* porque o preço por token tende a ser uma fração de
                                centavo. Número puro (sem símbolo de moeda), diferente de valor/custo,
                                pra preservar essa precisão sem sugerir arredondamento de 2 casas. */}
                            <ModelInputNumber model={model.precoexcedentetoken} contexto={contexto} minFractionDigits={2} maxFractionDigits={6} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.modalidade.aba.apresentacao')} leftIcon="pi pi-eye mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.destaque} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelInputNumber model={model.ordemexibicao} contexto={contexto} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelChips model={model.beneficios} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
            </TabViewComErro>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class ModalidadeTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={Modalidade}
                model={model}
                identidade="main.modalidade"
                permissoes={this.props.permissoes}
                icone="pi-money-bill"
                storageKey="dt-modalidades"
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <ModalidadeFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default ModalidadeTemplate;
